import all from './all';
import items from './items';
import store from './store';
import show from './show';
import update from './update';
import storeProduct from './storeProduct';
import bulkStoreProduct from './bulkStoreProduct';
import destroyProduct from './destroyProduct';

export default {
  all,
  items,
  store,
  show,
  update,
  storeProduct,
  bulkStoreProduct,
  destroyProduct,
};



// WEBPACK FOOTER //
// ./src/app/services/recipe/index.js